export default __webpack_public_path__ + "static/media/KAAN06.adc11c35.png";